export const TYPES = {
  SET_FINANCE_LIFE_ALL: "finance_life/SET_FINANCE_LIFE_ALL",
  SET_FINANCE_LIFE_OPEN_WITHDRAW: "finance_life/SET_FINANCE_LIFE_OPEN_WITHDRAW",
};
